import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPersonCircleRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M23.5 22.7c-1-2.4-3.2-4-5.9-4h-3.2c-2.7 0-5 1.6-6 4A10.4 10.4 0 0 1 16 5a10.4 10.4 0 0 1 7.5 17.6m-2 1.6a10 10 0 0 1-11 0 4 4 0 0 1 3.9-3.2h3.2a4 4 0 0 1 4 3.2m-5.5 4a12.8 12.8 0 1 0 0-25.6 12.8 12.8 0 0 0 0 25.6m0-13.6a2 2 0 1 1 0-4 2 2 0 0 1 0 4m-4.4-2a4.4 4.4 0 1 0 8.8 0 4.4 4.4 0 0 0-8.8 0" })
});
export default SvgPersonCircleRegularIcon;
